/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<g transform="translate(0 .07)" _fill="none" fill-rule="evenodd"><circle pid="0" _fill="#252B2F" cx="5.402" cy="5.402" r="5.402"/><path pid="1" d="M7.695 7.323L5.771 5.402 7.695 3.48a.26.26 0 1 0-.37-.37L5.402 5.033 3.478 3.112a.262.262 0 0 0-.37.369L5.032 5.4 3.108 7.324a.26.26 0 1 0 .37.369l1.924-1.921 1.923 1.921a.262.262 0 0 0 .37-.37z" _fill="#FFF" fill-rule="nonzero"/></g>'
  }
})
